import { throws } from 'assert';
import { Component } from 'react';
import { withRouter } from 'react-router-dom';

class ScrollToTop extends Component<any>{
    constructor(props) {
        super(props)
        // 产品详情页面进行路由跳转 跳转到链路优化h5
        if (this.props.location.pathname === "/productdetail") {
            window.location.href = process.env.REACT_APP_API_HOST + `/interauto/pages/index/index${this.props.location.search}`
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0)
        }
    }
    

    render() {
        return this.props.children
    }
}
export default withRouter(ScrollToTop);